import React, { Fragment, useState, useEffect, forwardRef } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { Search, Person } from '@material-ui/icons'
import MaterialTable, { MTableBodyRow } from 'material-table'
import Skeleton from '@material-ui/lab/Skeleton'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Alert from '@material-ui/lab/Alert'
import Moment from 'moment'

import { cardBodyStyle } from 'assets/jss/material-dashboard-react/components/cardBodyStyle'

const useStyles = makeStyles(cardBodyStyle)

const useStyles2 = makeStyles({
  tableRow: { '&:hover': { backgroundColor: 'rgb(237, 247, 237)!important' } },
})

export default function TestApplicantsDonePsychometrics(props) {
  const classes = useStyles()
  const classes2 = useStyles2()

  const tableIcons = {
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  }

  const [state] = useState({
    columns: [
      {
        title: 'Nombre',
        field: 'applicant.name',
        render: (rowData) => {
          return (
            <span>
              {rowData.applicant.name + ' ' + rowData.applicant.lastName}
            </span>
          )
        },
        width: '40%',
        cellStyle: {
          // whiteSpace: "nowrap",
          border: '1px solid rgb(241, 241, 241)',
          fontSize: 12,
        },
      },
      {
        title: 'Identificación',
        field: 'applicant.documentId',
        width: '10%',
        cellStyle: {
          // whiteSpace: "nowrap",
          border: '1px solid rgb(241, 241, 241)',
          fontSize: 12,
          textAlign: 'center',
        },
      },
      {
        title: 'Prueba',
        field: 'jobtesttpm.test.name',
        render: (rowData) => {
          // Formatea la fecha (si es string como "25-08-05" o "2025-08-05")
          const formattedDate = Moment(
            rowData.presentationDay,
            'YYYY-MM-DD'
          ).isValid()
            ? Moment(rowData.presentationDay).format('DD-MM-YYYY')
            : rowData.presentationDay
          return (
            <div>
              <div style={{ fontSize: 11, color: '#000', fontWeight: 400 }}>
                {rowData.jobtesttpm.test.name}
              </div>
              <div style={{ fontSize: 10, color: 'green', fontWeight: 'bold' }}>
                Fecha: {formattedDate}
              </div>
              <div style={{ fontSize: 10, color: 'green', fontWeight: 'bold' }}>
                Hora inicio:{' '}
                {Moment(rowData.startTimeDay, 'HH:mm:ss').format('HH:mm')} -
                Hora fin:{' '}
                {Moment(rowData.endTimeDay, 'HH:mm:ss').format('HH:mm')}
              </div>
            </div>
          )
        },
        width: '20%',
        cellStyle: {
          border: '1px solid rgb(241, 241, 241)',
          fontSize: 12,
        },
      },
    ],
  })

  useEffect(() => {
    if (props.refresh) {
      props.refreshReturn()
    }
  }, [])

  return (
    <Fragment>
      <Grid container spacing={1} className={classes.containerProfile}>
        {props.loader ? (
          <Grid item xs={12} sm={12}>
            <Box sx={{ width: '100%' }}>
              <Skeleton width="100%" height={300} />
            </Box>
          </Grid>
        ) : (
          <Fragment>
            <Grid item xs={12} sm={12}>
              <Alert severity="success" icon={<Person fontSize="inherit" />}>
                <b>
                  CANDIDATOS ASIGNADOS
                  <span style={{ marginLeft: 5, fontSize: 12 }}>
                    (Total: {props.users.length})
                  </span>
                </b>
              </Alert>
            </Grid>
            <Grid item xs={12} sm={12}>
              <MaterialTable
                title=""
                columns={state.columns}
                style={{
                  boxShadow: 'unset',
                  border: '1px solid rgb(241, 241, 241)',
                }}
                data={props.users || []}
                localization={{
                  toolbar: {
                    // nRowsSelected: '{0} row(s) selected',
                    searchTooltip: 'Filtrar',
                    searchPlaceholder: 'Buscar',
                  },
                  pagination: {
                    labelRowsSelect: 'Filas',
                    labelDisplayedRows: ' {from}-{to} de {count}',
                    firstTooltip: 'Primera página',
                    previousTooltip: 'Previo',
                    nextTooltip: 'Siguiente',
                    lastTooltip: 'Ultima página',
                  },
                  header: {
                    actions: ' --- ',
                  },
                  body: {
                    emptyDataSourceMessage: 'No hay datos.',
                    filterRow: {
                      filterTooltip: 'Filtro',
                    },
                  },
                }}
                actions={
                  [
                    /* {
                            icon: "edit",
                            tooltip: "Editar",
                            onClick: (event, rowData) => {
                              setOpenEditQuestion(true);
                              setIdRow(rowData);
                            },
                          },*/
                  ]
                }
                icons={tableIcons}
                options={{
                  search: true,
                  padding: 1,
                  filtering: false,
                  actionsColumnIndex: -1,
                  pageSize: 10,
                  headerStyle: {
                    background: '#F2F2F2',
                    padding: '1%',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  },
                  cellStyle: { border: '1px solid #DDDDDD' },
                }}
                components={{
                  Row: (props) => (
                    <MTableBodyRow className={classes2.tableRow} {...props} />
                  ),
                }}
              />
            </Grid>
          </Fragment>
        )}
      </Grid>
    </Fragment>
  )
}
